export class ContactDto {
  constructor(
    public name: string,
    public email: string,
  ) {}
}
